import {UserService} from "../../../../api/modules/userManagement/services/UserService";
import {MarketingMaterialItem} from "../../../../api/modules/marketingMaterial/models/MarketingMaterialItem";
import {StoreProxy} from "../../../../api/common/StoreProxy";
import {MimeTypeMapper} from "../../../../api/common/MimeTypeMapper";
import _ from 'lodash';
import Loading from 'vue-loading-overlay';

export default {
    name: "MarketingMaterialList",

    data() {
        return {
            _auth : '',
            isLoading: false,
            companyId: '',
            companies: [],
            items: []
        }
    },
    components: {
        Loading
    },
    created(){

        this._auth = StoreProxy.getAuth(this.$store);
        let service = new UserService(StoreProxy.getAuth(this.$store), (e) => {
            console.error(e)
        });

        service.getCompanies().then(companies => {
                if (companies != null) {
                    this.companies = companies;
                }
            }
        ).catch(error => {
            this.$notify.error({
                title: 'Internal Error',
                message: 'Unable to retrieve companies list.'
            });
        });
    },
    methods:{
        getIconName(mimeType){
          return MimeTypeMapper.getIconType(mimeType);
        },
        getFileLabel(mimeType){
          return MimeTypeMapper.getLabelType(mimeType);
        },
        loadItems(companyId){

            let vm = this;
            MarketingMaterialItem.getItemsForCompany(StoreProxy.getAuth(this.$store), companyId).then(items => {
                vm.items = items;
            }).catch(err => {

                if (!err) {
                    console.error(err);
                }

                this.$notify.error({
                    title: 'Internal Error',
                    message: 'Unable to retrieve marketing material list.'
                });

            });
        },
        companySelected(companyId){
            this.loadItems(companyId);
            console.debug(`[d634559] company selected ${companyId}`);
        },
        companyClear(){
            this.items = [];
            this.companyId = '';
        },
        changeActiveStatus(item){
            if (item.isActive){
                this.deactivateItem(item);
            }
            else
            {
                this.activateItem(item);
            }
        },
        deactivateItem(item){
            if (!item){
                throw new Error('[e023617] marketing material item for deactivation is not an object!');
            }

            item.deactivate(this._auth).then(resolve => {
                this.$notify.success('Item successfully deactivated');
            }).catch(reject => {
                console.error('[e863078] Error deactivating item!');
                if (!reject){
                    console.error(reject);
                }
                this.$notify.error({
                    title: 'Internal Error',
                    message: 'Failed to deactivate item. Please try again!.'
                });
            });
        },
        activateItem(item){
            item.activate(this._auth).then(resolve => {
                this.$notify.success('Item successfully activated!');
            }).catch(reject => {

                console.error('[e645750] Error activating item!');
                if (!reject){
                    console.error(reject);
                }

                this.$notify.error({
                    title: 'Internal Error',
                    message: 'Failed to activate item. Please try again!.'
                });
            });
        },
        downloadFile(item){
            if (!item){
                throw new Error('[e450885] marketing material item for download is not an object!' );
            }

            // check if file exists first.
            item.existsFile(this._auth).then(data => {
                if (data === true){
                    location.href = item.getDownloadUrl(this._auth);
                }
                else{
                    this.$alert('File not found in the server.\nPlease contact your administrator.', 'File Not Found', {
                        confirmButtonText: 'OK'
                    });
                }
            }).catch(err => {
                this.$notify.error({
                    title: 'Internal Error',
                    message: 'Server error when checking for file!. Please contact support.'
                });
            });

        },
        deleteFile(item){
            if (!item){
                throw new Error('[e414253] marketing material item for deleting is not an object!' );

            }

            let vm = this;

            item.delete(this._auth).then(itemId => {

                console.log(itemId);
                _.remove(vm.items, function(tmpItem){
                    return tmpItem.itemId === itemId || tmpItem.itemId === '';
                });

                this.$notify.success('Item successfully deleted!');
            }).catch(error => {
                this.$notify.error({
                    title: 'Internal Error',
                    message: 'Failed to delete item. Please try again!.'
                });
            });
        }

    }

}